<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import accommodation from '../../../helpers/list/accommodation';
import city from '../../../helpers/list/city';

export default {
  components: {},
  props: {},
  data() {
    return {
      accommodation_id: "",
      region: "",
      city_id: "",
      nearest_point: "",
      mahla: "",
      zqaq: "",
      dar: "",

      //list
      list_accommodation: accommodation,
      list_city: city,
    };
  },
  validations: {
    accommodation_id: { required },
    region: { required, minLength: minLength(2), maxLength: maxLength(50) },
    city_id: { required },
    nearest_point: { required, minLength: minLength(2), maxLength: maxLength(50) },
    mahla: { maxLength: maxLength(10) },
    zqaq: { maxLength: maxLength(10) },
    dar: { maxLength: maxLength(10) },

    form: [
      "accommodation_id",
      "region",
      "city_id",
      "nearest_point",
      "mahla",
      "zqaq",
      "dar",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات السكن</h5></div>

      <b-form-group
        class="col-md-6 mb-3"
        label=" نوع السكن  : "
        label-for="accommodation_id"
      >
        <select
          class="form-control"
          id="accommodation_id"
          v-model="accommodation_id"
          :class="{ 'is-invalid': $v.accommodation_id.$error }"
        >
          <option value="">اختر نوع السكن</option>
          <option v-for="accommodation in list_accommodation" :value="accommodation.id" :key="accommodation.id">{{accommodation.name}}</option>
        </select>
        <div v-if="$v.accommodation_id.$error" class="invalid-feedback">
          <span v-if="!$v.accommodation_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" المحافظة  : " label-for="city_id">
        <select
          class="form-control"
          id="city_id"
          v-model="city_id"
          :class="{ 'is-invalid': $v.city_id.$error }"
        >
          <option value="">اختر المحافظة</option>
          <option v-for="city in list_city" :value="city.id" :key="city.id">{{city.name}}</option>
        </select>
        <div v-if="$v.city_id.$error" class="invalid-feedback">
          <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label="المنطقة : " label-for="region">
        <b-form-input
          id="region"
          type="text"
          placeholder="ادخل المنطقة"
          v-model="region"
          :class="{ 'is-invalid': $v.region.$error }"
        ></b-form-input>
        <div v-if="$v.region.$error" class="invalid-feedback">
          <span v-if="!$v.region.required">هذا الحقل الزامي</span>
          <span v-if="!$v.region.minLength">يجب أن تتكون المنطقة من حرفين على الأقل</span>
          <span v-if="!$v.region.maxLength"
            >يجب أن تتكون المنطقة من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label="اقرب نقطة دالة : "
        label-for="nearest_point"
      >
        <b-form-input
          id="nearest_point"
          type="text"
          placeholder="ادخل اقرب نقطة دالة"
          v-model="nearest_point"
          :class="{ 'is-invalid': $v.nearest_point.$error }"
        ></b-form-input>
        <div v-if="$v.nearest_point.$error" class="invalid-feedback">
          <span v-if="!$v.nearest_point.required">هذا الحقل الزامي</span>
          <span v-if="!$v.nearest_point.minLength"
            >يجب أن تكون اقرب نقطة دالة من حرفين على الأقل</span
          >
          <span v-if="!$v.nearest_point.maxLength"
            >يجب أن تكون اقرب نقطة دالة من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label="المحلة : " label-for="mahla">
        <b-form-input
          id="mahla"
          type="text"
          placeholder="ادخل المحلة"
          v-model="mahla"
          :class="{ 'is-invalid': $v.mahla.$error }"
        ></b-form-input>
        <div v-if="$v.mahla.$error" class="invalid-feedback">
          <span v-if="!$v.mahla.maxLength">يجب أن تكون المحلة من 10 احرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label="الزقاق : " label-for="zqaq">
        <b-form-input
          id="zqaq"
          type="text"
          placeholder="ادخل الزقاق"
          v-model="zqaq"
          :class="{ 'is-invalid': $v.zqaq.$error }"
        ></b-form-input>
        <div v-if="$v.zqaq.$error" class="invalid-feedback">
          <span v-if="!$v.zqaq.maxLength">يجب أن يتكون الزقاق من 10 احرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label="الدار : " label-for="dar">
        <b-form-input
          id="dar"
          type="text"
          placeholder="ادخل الدار"
          v-model="dar"
          :class="{ 'is-invalid': $v.dar.$error }"
        ></b-form-input>
        <div v-if="$v.dar.$error" class="invalid-feedback">
          <span v-if="!$v.dar.maxLength">يجب أن يتكون الدار من 10 احرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
